import React, { useState, useEffect, useRef, useContext } from "react";
import nlpSearchService from "../services/NlpSearchService";
import { AuthContext } from "../store/ContextStore";
import localStorageService from "../services/localStorageService";

const SearchWithSuggestions: React.FC<{
  onSelect: (selectedValue: string) => void;
  handleDropdownChange: any;
}> = ({ onSelect, handleDropdownChange }) => {
  const [inputValue, setInputValue] = useState("");
  const [suggestions, setSuggestions] = useState<string[]>([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [debouncedInput, setDebouncedInput] = useState(""); // Debounced value
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const searchRef = useRef<HTMLDivElement>(null); // Ref for detecting outside clicks
  
  const nlpFilter = localStorageService.getNLPFilter()
  const { selectedSport, user, team } = useContext(AuthContext)

  const nlp_SearchService = new nlpSearchService()

  const getSuggestionList = async (query: string): Promise<string[] | string> => {
    if (!query.trim()) return [];

    setLoading(true);
    setError(null);
    try {
      const payload = {
        SportCode: selectedSport,
        Entity: nlpFilter.entity,
        Prefix: query,
      };
      const response = await nlp_SearchService.getNameSuggestions(payload);
      setLoading(false);
      return response; // Either an array of suggestions or an error string
    } catch (err) {
      setLoading(false);
      setError("Something went wrong. Please try again.");
      return "error";
    }
  };

  // Debounce logic
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedInput(inputValue);
    }, 300);

    return () => clearTimeout(handler);
  }, [inputValue]);

 useEffect(() => {
  if (debouncedInput.trim()) {
    getSuggestionList(debouncedInput).then((res) => {
      if (typeof res === "string") {
        setError(res);
        setSuggestions([]); // <-- ensure array
      } else if (Array.isArray(res)) {
        setError(null);
        setSuggestions(res);
      } else {
        setSuggestions([]); // <-- default safe value
      }
    });
  } else {
    setSuggestions([]);
    setError(null);
  }
}, [debouncedInput]);


    // Close dropdown when clicking outside
    useEffect(() => {
      const handleClickOutside = (event: MouseEvent) => {
        if (searchRef.current && !searchRef.current.contains(event.target as Node)) {
          setShowSuggestions(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);
  


  return (
    <div className="relative w-full">
      <div className="relative w-full">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="2"
          stroke="currentColor"
          className="absolute left-2 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-500"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M21 21l-4.35-4.35m0 0a7.5 7.5 0 1 0-10.606 0 7.5 7.5 0 0 0 10.606 0z"
          />
        </svg>
        {/* Input Field */}
        <input
          type="text"
          value={inputValue}
          placeholder="Search for a name..."
          onChange={(e) => setInputValue(e.target.value)}
          onFocus={() => setShowSuggestions(true)}
          onKeyDown={(e) => e.key === "Enter" && e.preventDefault()} // Prevent Enter submission
          className="w-full max-h-8 text-sm font-primary font-normal border border-[#D3D3D3] rounded-[6px] px-8 py-2"
        />
      </div>

      {/* Suggestions Dropdown */}
      {showSuggestions && (
        <div ref={searchRef} className="absolute w-full mt-1 bg-white border border-gray-300 rounded shadow-md z-10 max-h-48 overflow-y-auto custom-scrollbar">
          {loading ? (
            <div className="p-2 text-gray-500 text-center">Loading...</div>
          ) : error ? (
            <div className="p-2 text-red-500 text-center">{error}</div>
         ) : Array.isArray(suggestions) && suggestions.length > 0 ? (
            <ul>
              {suggestions.map((suggestion, index) => (
                <li
                  key={index}
                  onClick={() => {
                    handleDropdownChange("PLAYER", suggestion);
                    setInputValue("");
                    setShowSuggestions(false);
                  }}
                  className="p-2 cursor-pointer hover:bg-gray-100"
                >
                  {suggestion}
                </li>
              ))}
            </ul>
          ) : (
            <div className="p-2 text-gray-500 text-center">No data found</div>
          )}
        </div>
      )}
    </div>
  );
};

export default SearchWithSuggestions;





